import { useState, useEffect } from 'react'; // Import useEffect
import { Link, useNavigate } from 'react-router-dom';
import { login } from '../services/authService';
import { connectSocket } from '../socket';
import { isAuthenticated, getUserRole } from '../utils/auth'; // Assuming isAuthenticated and getUserRole are available
import Logo from '../components/images/logo.png';
import { ClipLoader } from 'react-spinners'; // Assuming you have react-spinners installed for the loader

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  // --- Add this useEffect hook ---
  useEffect(() => {
    if (isAuthenticated()) {
      const role = getUserRole(); // Get the user's role if authenticated
      if (role === 'student') {
        navigate('/'); // Redirect student to homepage
      } else {
        navigate('/dashboard'); // Redirect admin/teacher to dashboard
      }
    }
  }, [navigate]); // navigate as a dependency to prevent linting warnings

  // --- End of useEffect hook ---

  const handleLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const res = await login(email, password);
      console.log('Login response:', res);
      if (res && res.data && res.data.token && res.data.role) {
        localStorage.setItem('token', res.data.token);
        localStorage.setItem('role', res.data.role);
        localStorage.setItem('userId', res.data.userId);
        connectSocket();

        // The useEffect will handle the initial redirect upon login,
        // but it's good to keep this logic here for immediate navigation post-login.
        if (res.data.role === 'student') {
          navigate('/');
        } else {
          navigate('/dashboard');
        }
      } else {
        alert('Login failed: Invalid token or role received');
      }
    } catch (err) {
      console.error(err);
      alert('Login failed');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className='page-container'>
      <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
        {/* Navigation Bar */}
        <nav style={{ backgroundColor: '#f8f9fa', padding: '15px 20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #eee' }}>
          {/* Logo */}
          <div style={{ fontSize: '1.5em', fontWeight: 'bold', color: '#007bff' }}>
            <img src={Logo} alt="Learning Aids" height={35} />
          </div>
          {/* Navigation Links */}
          <div>
            {/* You might want to conditional render these links based on authentication status */}
            {isAuthenticated() ? (
                // If authenticated, show logout/dashboard or nothing for login page
                <button
                    style={{ backgroundColor: '#dc3545', color: 'white', border: 'none', padding: '8px 15px', borderRadius: '5px', cursor: 'pointer', marginRight: '10px', textDecoration: 'none' }}
                    onClick={() => {
                        // Assuming you have a logout function accessible here
                        localStorage.removeItem('token');
                        localStorage.removeItem('role');
                        localStorage.removeItem('userId');
                        navigate('/'); // Redirect after logout
                    }}
                >
                    Logout
                </button>
            ) : (
                <>
                    <Link to="/login" style={{ color: '#007bff', textDecoration: 'none', marginRight: '15px' }}>Login</Link>
                    <Link to="/register" style={{ color: '#007bff', textDecoration: 'none' }}>Register</Link>
                </>
            )}
          </div>
        </nav>
        <div className='wrapper'>
          <div className='form-wrapper animated fadeInUp'>
            <div className='form-wrapper-inner text-center'>
              <div className='form-title'>
                <img src={Logo} alt="Learning Aids" />
                <h2>Login</h2>
              </div>
              <form onSubmit={handleLogin}>
                <div className='form-field'>
                  <input
                    type="email"
                    placeholder="Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    className='input-text'
                    disabled={isLoading}
                  />
                </div>
                <div className='form-field'>
                  <input
                    type="password"
                    placeholder="Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    className='input-text'
                    disabled={isLoading}
                  />
                </div>
                <div className='form-field-submit'>
                  <button type="submit" disabled={isLoading}>
                    {isLoading ? (
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                        <ClipLoader size={20} color={"#fff"} /> Logging in...
                      </div>
                    ) : (
                      'Login'
                    )}
                  </button>
                </div>
                <hr />
                <p className="text-muted">Do not have an account? <a href="/register"> Sign Up here</a></p>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;